module.exports = __webpack_public_path__ + "static/media/NSCA_CPT1.1c930363.jpg";